// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resetPasswordStyles } from "@guestsupply/Overrides/Widgets/ResetPassword/ResetPassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.passwordGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 500px;
                    `,
                ],
                "min",
            )}
        margin: 0;
    `,
};
resetPasswordStyles.newPasswordGridItem = {
    width: [12, 8, 8, 12, 12],
};
resetPasswordStyles.confirmNewPasswordGridItem = {
    width: [12, 8, 8, 12, 12],
};
resetPasswordStyles.submitGridItem = {
    ...resetPasswordStyles.submitGridItem,
    width: [12, 8, 8, 12, 12],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
resetPasswordStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};
resetPasswordStyles.instructionsText = {
    css: css`
        margin-bottom: 10px;
    `,
};
resetPasswordStyles.requirementsGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: 50px;
                    `,
                ],
                "min",
            )}
    `,
};
resetPasswordStyles.passwordRequirementsGridContainer = {
    gap: 5,
};
resetPasswordStyles.passwordRequirementsGridItem = {
    width: 12,
};
resetPasswordStyles.requirementsTitle = {
    variant: "h4",
    as: "h2",
};
resetPasswordStyles.pageTitle = {
    variant: "h2",
    as: "h1",
    weight: 400,
};
